import React from "react"

const TableHeader = ({ period, months }: $TSMigrationFixMe) => {
  return (
    <thead className='tw-sticky tw-top-0 tw-bg-white'>
      <tr className='tw-z-10 tw-shadow-md'>
        <th />
        {months?.map((month: $TSMigrationFixMe) => {
          return (
            <>
              {period ? (
                <th
                  key={months.value}
                  className='tw-py-4 tw-px-2 tw-whitespace-nowrap tw-text-sm tw-font-medium tw-min-w-25 tw-capitalize'
                >
                  {month.value}
                </th>
              ) : (
                <th
                  key={month.value}
                  className='tw-p-4 tw-px-2'
                >
                  Total
                </th>
              )}
            </>
          )
        })}
      </tr>
    </thead>
  )
}

export default React.memo(TableHeader)
